import React, { useState } from 'react';
import { StatusBadge, StatusType } from './StatusBadge';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface ProgressStepProps {
  status: StatusType;
  label: string;
  timestamp?: string;
  details?: React.ReactNode;
  isLast?: boolean;
}
export function ProgressStep({
  status,
  label,
  timestamp,
  details,
  isLast = false
}: ProgressStepProps) {
  const [expanded, setExpanded] = useState(false);
  return <div className="relative flex gap-4" data-id="element-174">
      {!isLast && <div className="absolute left-3.5 top-8 bottom-0 w-px bg-border -ml-px" aria-hidden="true" data-id="element-175" />}

      <div className="relative z-10 flex-shrink-0 mt-1" data-id="element-176">
        <StatusBadge status={status} label="" className="!p-1.5 [&>svg]:w-4 [&>svg]:h-4 [&>svg]:mr-0" data-id="element-177" />
      </div>

      <div className="flex-1 pb-8" data-id="element-178">
        <div className={`flex items-center justify-between ${details ? 'cursor-pointer group' : ''}`} onClick={() => details && setExpanded(!expanded)} data-id="element-179">
          <div className="flex flex-col" data-id="element-180">
            <span className={`font-medium ${status === 'pending' ? 'text-muted-foreground' : 'text-foreground'}`} data-id="element-181">
              {label}
            </span>
            {timestamp && <span className="text-xs text-muted-foreground mt-0.5" data-id="element-182">
                {timestamp}
              </span>}
          </div>

          {details && <button className="text-muted-foreground group-hover:text-foreground p-1" data-id="element-183">
              {expanded ? <ChevronUpIcon className="w-4 h-4" data-id="element-184" /> : <ChevronDownIcon className="w-4 h-4" data-id="element-185" />}
            </button>}
        </div>

        {details && expanded && <div className="mt-3 p-4 bg-pk-surface rounded-lg border border-border text-sm animate-accordion-down" data-id="element-186">
            {details}
          </div>}
      </div>
    </div>;
}